import React from 'react';
import PropTypes from 'prop-types';
import './Spinner.scss';
import { createClassList } from '../../utils/dom/class';

const Spinner = ({ mode, classes }) => (
  <div
    className={createClassList({
      default: [
        'axiom-spinner',
        `spinner ${mode === 'light' ? 'spinner--light' : ''}`,
      ],
      custom: classes,
      required: [],
    })}
    data-testid='spinner'
  >
    <svg
      width='61'
      height='61'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 61 61'
    >
      <g fillRule='evenodd'>
        <rect x='28' width='5' height='18' rx='2' />
        <rect
          fillOpacity='.52'
          x='28'
          y='43'
          width='5'
          height='18'
          rx='2'
        />
        <path
          d='M14.815 4.313l.637-.364a2 2 0 012.683.669l7.748 12.264a2 2 0 01-.698 2.805l-.637.364a2 2 0 01-2.683-.669L14.117 7.118a2 2 0 01.698-2.805z'
          fillOpacity='.92'
        />
        <path
          d='M35.815 41.313l.637-.364a2 2 0 012.683.669l7.748 12.264a2 2 0 01-.698 2.805l-.637.364a2 2 0 01-2.683-.669l-7.748-12.264a2 2 0 01.698-2.805z'
          fillOpacity='.44'
        />
        <path
          d='M3.888 15.576l.375-.699a2 2 0 012.817-.753l12.325 7.655a2 2 0 01.707 2.645l-.375.699a2 2 0 01-2.817.753L4.595 18.22a2 2 0 01-.707-2.645z'
          fillOpacity='.84'
        />
        <path
          d='M40.888 36.576l.375-.699a2 2 0 012.817-.753l12.325 7.655a2 2 0 01.707 2.645l-.375.699a2 2 0 01-2.817.753L41.595 39.22a2 2 0 01-.707-2.645z'
          fillOpacity='.36'
        />
        <rect
          fillOpacity='.76'
          transform='rotate(-90 9 30.5)'
          x='6.5'
          y='21.5'
          width='5'
          height='18'
          rx='2'
        />
        <rect
          fillOpacity='.28'
          transform='rotate(-90 52 30.5)'
          x='49.5'
          y='21.5'
          width='5'
          height='18'
          rx='2'
        />
        <path
          d='M4.263 46.123l-.375-.7a2 2 0 01.707-2.644l12.325-7.655a2 2 0 012.817.753l.375.7a2 2 0 01-.707 2.644L7.08 46.876a2 2 0 01-2.817-.753z'
          fillOpacity='.68'
        />
        <path
          d='M41.263 25.123l-.375-.7a2 2 0 01.707-2.644l12.325-7.655a2 2 0 012.817.753l.375.7a2 2 0 01-.707 2.644L44.08 25.876a2 2 0 01-2.817-.753z'
          fillOpacity='.2'
        />
        <path
          d='M15.576 57.112l-.699-.375a2 2 0 01-.753-2.817l7.655-12.325a2 2 0 012.645-.707l.699.375a2 2 0 01.753 2.817L18.22 56.405a2 2 0 01-2.645.707z'
          fillOpacity='.6'
        />
        <path
          d='M36.576 20.112l-.699-.375a2 2 0 01-.753-2.817L42.78 4.595a2 2 0 012.645-.707l.699.375a2 2 0 01.753 2.817L39.22 19.405a2 2 0 01-2.645.707z'
          fillOpacity='.12'
        />
      </g>
    </svg>
  </div>
);

Spinner.propTypes = {
  mode: PropTypes.oneOf(['light', 'dark']),
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Spinner.defaultProps = {
  mode: 'dark',
  classes: [],
};

export default Spinner;
